import { EraseAllToolScope } from 'generated/graphql';
import Text from 'common/ui/Text';
import { Stack, Spacer } from 'common/ui/Layout';
import { useCallback } from 'react';
import SettingsDropdown from 'common/SettingsDropdown';
import { useEraseAllToolScopeSetting } from 'hooks/useViewerSettings';
import { SettingsMenuItem } from 'common/SettingsDropdown/SettingsDropdown';

const ERASE_ALL_SCOPE_FIELD_LABEL = 'Erase All tool behavior';
const ERASE_ALL_SCOPE_VALUES = [
  { name: 'Erase in Viewport Only', value: EraseAllToolScope.Viewport },
  { name: 'Erase All Annotations in Study', value: EraseAllToolScope.Study },
];

export const EraseAllToolScopeSettings = (): React.ReactElement => {
  const [eraseAllToolScope, setEraseAllToolScope] = useEraseAllToolScopeSetting();

  const handleEraseAllScopeChange = useCallback(
    async (eventValue: EraseAllToolScope) => {
      await setEraseAllToolScope(eventValue);
    },
    [setEraseAllToolScope]
  );

  return (
    <>
      <Stack alignY="center">
        <Text>{ERASE_ALL_SCOPE_FIELD_LABEL}</Text>
        <Spacer />
        <SettingsDropdown
          value={eraseAllToolScope || EraseAllToolScope.Viewport}
          onSelectedChange={(value) => {
            const eraseAllToolScopeValue = value as EraseAllToolScope;
            handleEraseAllScopeChange(eraseAllToolScopeValue);
          }}
          data-testid="erase-all-preference"
        >
          {ERASE_ALL_SCOPE_VALUES.map((option) => (
            <SettingsMenuItem
              id={`erase-all-preference-menuitem-${option.value}`}
              value={option.value}
              key={option.value}
              data-testid={`${option.value}-menu-item`}
            >
              {option.name}
            </SettingsMenuItem>
          ))}
        </SettingsDropdown>
      </Stack>
    </>
  );
};
